import request from '@/utils/request'


// 查询医院信息列表
export function listHospital(query) {
  return request({
    url: '/hospital/hospital/list',
    method: 'get',
    params: query
  })
}

// 查询医院信息分页
export function pageHospital(query) {
  return request({
    url: '/hospital/hospital/page',
    method: 'get',
    params: query
  })
}

// 查询医院信息详细
export function getHospital(data) {
  return request({
    url: '/hospital/hospital/detail',
    method: 'get',
    params: data
  })
}

// 新增医院信息
export function addHospital(data) {
  return request({
    url: '/hospital/hospital/add',
    method: 'post',
    data: data
  })
}

// 修改医院信息
export function updateHospital(data) {
  return request({
    url: '/hospital/hospital/edit',
    method: 'post',
    data: data
  })
}

// 删除医院信息
export function delHospital(data) {
  return request({
    url: '/hospital/hospital/delete',
    method: 'post',
    data: data
  })
}

export function importHospital(data) {
  return request({
    url: '/hospital/hospital/import',
    method: 'post',
    data: data
  })
}

// 设置和取消百强
export function changeHospitalTop100Status (id, isTop100, top100Rank) {
  const data = {
    id,
    isTop100,
    top100Rank
  }
  return request({
    url: '/hospital/hospital/changeIsTop',
    method: 'put',
    data: data
  })
}

// 同步医院华歧系数
export function syncHospitalScore(data = []) {
  return request({
    url: '/hospital/hospital/syncHospitalScore',
    method: 'put',
    data: data
  })
}

// 查询某个医院的华歧系数详情
export function getHospitalScoreDetail(hospitalId) {
  return request({
    url: '/hospital/hospitalScoreDetail/detailByHospitalId',
    method: 'get',
    params: { hospitalId: hospitalId }
  })
}

// 自主加减分
export function adjustHospitalScore(id, changeScore) {
  const data = { id, changeScore }
  return request({
    url: '/hospital/hospital/changeScore',
    method: 'put',
    data: data
  })
}
